import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import usePortManager from '../../hooks/use-port-manager'
import axios from 'axios'
import ProductInput from './ProductInput'
import Spinner from '../../misc/Spinner'
import usePriceManager from '../../hooks/use-price-manager'
import useSettingsManager from '../../hooks/use-settings-manager'

function InputExtraProducts (props) {
  const settings_manager = useSettingsManager()
  const port_manager = usePortManager()
  const price_manager = usePriceManager()
  const name = props.name

  const [products, setProducts] = useState(null)
  const [axios_cancel_source, setAxiosCancelSource] = useState(axios.CancelToken.source())

  useEffect(() => {
    if (products === null) fetchProducts()
    return function unmount () {
      axios_cancel_source.cancel('AxiosCancelUnmounted')
    }
  }, [])

  const getUserProductChoices = function () {
    let choices = port_manager.getValue(name)
    if (typeof choices !== 'object') choices = []
    return choices
  }
  const updateUserProductChoices = function (choices) {
    port_manager.updateValue(name, choices)
    price_manager.updatePrice()
  }

  const fetchProducts = function () {
    let data = new FormData()
    data.append('action', 'nassau_port_config_extra_products')
    axios.post(
      window.main_theme_objects.ajax_url,
      data,
      { cancelToken: axios_cancel_source.token }
    )
      .then(function (response) {
        if (response.status !== 200) return
        if (typeof response.data !== 'object') return
        setProducts(response.data)
      }).catch(function (error) {
      if (error.message === 'AxiosCancelUnmounted') {
        return
      }
    })
  }

  const onProductChange = function (product) {
    let choices = getUserProductChoices()
    let clen = choices.length
    for (let i = 0; i < clen; i++) {
      if (choices[i].product_id == product.product_id) {
        choices[i] = product
        updateUserProductChoices(choices)
        return
      }
    }
    choices.push(product)
    updateUserProductChoices(choices)
  }

  const getProductQuantity = function (product_id) {
    let choices = getUserProductChoices()
    let clen = choices.length

    for (let i = 0; i < clen; i++) {
      if (choices[i].product_id == product_id) return choices[i].quantity
    }
    return 0
  }

  const loading_element = (<div>
    {
      settings_manager.getOtherSettings(
        'products_loading',
        'Henter produktliste...'
      )
    }
    <Spinner/></div>)

  const items = products === null ? null : products.map((product, index) => <ProductInput key={index} product={product}
                                                                                          quantity={getProductQuantity(product.product_id)}
                                                                                          onChange={onProductChange}/>)

  return (
    <>
      {items === null ? loading_element : items}
    </>
  )
}

export default observer(InputExtraProducts)